module.exports = __webpack_public_path__ + "img/modelo_carga_estudiantes.987629f1.png";